import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";
import commonFn from "@/commons/commonFunction";
class MerchantTransactionControlAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "merchanttransactioncontrolreports";
  /**
   * @override
   * Tìm kiếm thông tin công ty theo taxcode or Name
   * Created by: pvtruong 12/10/2022
   */
  getList(payload) {
    let param = {
      maxResultCount: payload.take || 20,
      filter: payload.filter || null,
      skipCount: payload.skip || 0,
      sorting: payload.Sort || null,
    };

    let url = this.getAPIUrl() + "/list";
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.postAsync(request);
  }

  async exportDetail(payload) {
    let url = `${this.getAPIUrl()}/merchant/exportdetail`;
    let req = {
      url: url,
      data: {
        id: payload.id,
        fileName: payload.fileName,
        merchantCode: payload.merchantCode,
        controlReportDate: payload.controlReportDate,
        paymentPeriodDate: payload.paymentPeriodDate,
        typeExport: payload.typeExport,
      },
      responseType: "blob",
    };
    var result = await this.postAsync(req);
    const urlResult = window.URL.createObjectURL(new Blob([result]));
    const link = document.createElement("a");
    link.href = urlResult;
    link.setAttribute("download", payload.fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
  }

  /**
   * Xác nhận thanh toán
   */
  markPaidManyAsync(param) {
    let url = this.getAPIUrl() + "/markpaid/many";
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.postAsync(request);
  }
  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getEdit(payload) {
    let request = {
      url: [this.getAPIUrl(), payload.id].join("/merchants/"),
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy bb đối soát theo id
   */
  getControlReportById(id) {
    let request = {
      url: this.getAPIUrl() + `/controlreport/${id}`,
    };

    return httpClient.getAsync(request);
  }
}

export default new MerchantTransactionControlAPI();
